import { render, staticRenderFns } from "./EndpointEdit.vue?vue&type=template&id=f1e9ec0c&"
import script from "./EndpointEdit.vue?vue&type=script&lang=js&"
export * from "./EndpointEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports